import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator, Logger } from '@ngrx/data';
import { EMPTY, Observable } from 'rxjs';
import { expand, reduce } from 'rxjs/operators';

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
};

@Injectable()
export class SwayDeviationDataService extends DefaultDataService<any> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, logger: Logger) {
        super('Deviation', http, httpUrlGenerator);
        logger.log('Created custom Deviation EntityDataService');
    }

    override getWithQuery(params: { msp: string; tenant: string; start: string; end: string }): Observable<any[]> {
        return this.http
            .get<any>(`/api/report/tenant/${params.tenant}/deviations`, {
                headers: {
                    ...headers,
                    'msp-id': params.msp,
                    'tenant-id': params.tenant,
                },
            })
            .pipe(
                expand((data) => {
                    if (data.offset) {
                        return this.http.get<any[]>(
                            `/api/report/tenant/${params.tenant}/deviations?offset=${data.offset}`,
                            {
                                headers: {
                                    ...headers,
                                    'msp-id': params.msp,
                                    'tenant-id': params.tenant,
                                },
                            },
                        );
                    } else {
                        return EMPTY;
                    }
                }),
                reduce((acc, data: any) => acc.concat(data.records), []),
            );
    }
}
